import { ContinueShoppingDataType } from '@client/components/continue-shopping/types';

export const NAMESPACE = 'continueShopping';

export interface State {
    data: ContinueShoppingDataType;
    loading: boolean;
    error?: string;
}

export const initialState: State = {
    data: [],
    loading: false,
    error: undefined,
};
